import { Link } from 'react-router-dom';
// mantine
import { Button } from '@mantine/core';
// utils
import { PATHS } from '@/const';

const NotFound = () => (
    <div className="flex flex-col justify-center items-center gap-2 py-60 font-bold">
        <div className="text-[10rem] leading-none">404</div>
        <div className="text-4xl mb-6">Page not found</div>
        <Button component={Link} size="md" to={PATHS.projects}>
            Back to Home
        </Button>
    </div>
);

export default NotFound;
